//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  IconLock,
  Illustration,
  Tag,
  Typography,
} from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'
import { mapGetters } from 'vuex'

import { Prices } from '@app/components/prices'
import { COUNTRIES } from '@config/constants'
import Carrier from '@product/components/Carrier'
// We have an issue with import from index.js in vanishing-deals
// Because of import ProductThumb in ModalGoodDeal
// ModalGoodDeal import in Pickle Analysis
// Pickel Analysis export in index vanishing-deals ...
import VanishingTimer from '@vanishing/components/VanishingTimer'

import Card from '../../Card/Card'
import productThumbTranslations from '../ProductThumb.translations'

import translations from './Card.translations'

export const COUNTRIES_WITH_EXTENDED_DISPLAY = [COUNTRIES.FR]

export default {
  components: {
    Card,
    Tag,
    Illustration,
    Carrier,
    IconLock,
    VanishingTimer,
    Typography,
    Prices,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    titleModel: {
      type: String,
      default: '',
    },
    subTitleModel: {
      type: Array,
      default: () => [],
    },
    thumbnail: {
      type: String,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} price
     * @property {number} price.raw
     * @property {string} price.display
     */
    price: {
      type: Object,
      required: true,
    },
    /**
     * Before Backmarket's price
     *
     * @typedef {object} originalPrice
     * @property {number} originalPrice.raw
     * @property {string} originalPrice.display
     */
    originalPrice: {
      type: Object,
      required: true,
    },
    warranty: {
      type: [String, Number],
      required: true,
    },
    grade: {
      type: String,
      default: '',
    },
    /**
     * Carriers Details
     *
     * @typedef {object} carriers
     * @property {Array} carriers.list
     * @property {Boolean} carriers.locked
     * @property {Boolean} carriers.showCarrier
     */
    carriers: {
      type: Object,
      default: () => ({}),
    },
    isRecommendation: {
      type: Boolean,
      default: false,
    },
    isVanishing: {
      type: Boolean,
      default: false,
    },
    stockRaw: {
      type: Number,
      default: 0,
    },
    pressureStockLimit: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      country: 'config/country',
    }),
    hasExtendedDisplay() {
      return COUNTRIES_WITH_EXTENDED_DISPLAY.includes(this.country)
    },
    originalPriceDisplay() {
      if (this.hasExtendedDisplay) {
        return this.$t(productThumbTranslations.originalPriceDisplay, {
          price: this.originalPrice.display,
        })
      }

      return this.originalPrice.display
    },
    translations: () => translations,
    productThumbTranslations: () => productThumbTranslations,
    displayVanishingTag() {
      return this.isRecommendation && this.isVanishing
    },
    displayRecoTag() {
      return this.isRecommendation && !this.isVanishing
    },
    displayTitle() {
      return !this.displaySmartphoneDetails
    },
    displaySmartphoneDetails() {
      return !isEmpty(this.subTitleModel)
    },
    subTitleModelString() {
      return this.subTitleModel && this.subTitleModel.join(' - ')
    },
    displayCarrier() {
      return this.carriers.hasCarrier && !isEmpty(this.carriers.list)
    },
    displayWarranty() {
      return this.warranty && !this.isVanishing
    },
    gradeFormatted() {
      return this.$t(translations.productThumbCondition, { grade: this.grade })
    },
  },
}
